import React from 'react';
import { useTranslation } from 'react-i18next';
import FormField from 'components/FormField';
import { RECOMMENDED_PLAYLIST_THUMBNAIL_SIZE, RECOMMENDED_ASSET_THUMBNAIL_SIZE } from 'screens/ThumbnailPreview';
import ThumbnailEditor from 'components/ThumbnailEditor';
var ImageField = function ImageField(_ref) {
  var id = _ref.id,
    thumbnailId = _ref.thumbnailId,
    onChange = _ref.onChange,
    isDisabled = _ref.isDisabled,
    assetType = _ref.assetType,
    contentType = _ref.contentType,
    contentId = _ref.contentId,
    contentName = _ref.contentName,
    contentDescription = _ref.contentDescription,
    badge = _ref.badge;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var isPlaylist = contentType === 'playlist-thumbnail';
  var content = {
    id: contentId,
    name: contentName,
    description: contentDescription,
    thumbnailId: thumbnailId,
    fileType: contentType,
    type: assetType,
    badge: isPlaylist ? badge : undefined
  };
  return /*#__PURE__*/React.createElement(FormField, {
    required: true,
    id: id,
    label: t('form_cover_image'),
    description: t('form_cover_image_hint', {
      size: isPlaylist ? RECOMMENDED_PLAYLIST_THUMBNAIL_SIZE : RECOMMENDED_ASSET_THUMBNAIL_SIZE
    })
  }, /*#__PURE__*/React.createElement(ThumbnailEditor, {
    isDisabled: isDisabled,
    hasUploadSuccessAlert: false,
    id: id,
    maxHeight: 150,
    onUploadThumbnail: function onUploadThumbnail(newThumbnailId) {
      return onChange(newThumbnailId);
    },
    onRemoveThumbnail: function onRemoveThumbnail() {
      return onChange(null);
    },
    content: content
  }));
};
export default ImageField;